module.exports = __webpack_public_path__ + "img/ic_light_blue.a8fba3e6.png";